import {
	Alert,
	Box,
	Button,
	Chip,
	Fade,
	FormHelperText,
	Grid,
	IconButton,
	Input,
	Modal,
	Paper,
	Popper,
	Snackbar,
} from '@mui/material';
import { GridAddIcon } from '@mui/x-data-grid';
import CancelIcon from '@mui/icons-material/Cancel';
import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import {
	Add,
	Close,
	Delete,
	DeleteOutline,
	DeleteForever,
	Edit,
	EditOutlined,
	ExpandLess,
	ExpandMore,
	ListAltOutlined,
	RemoveCircleOutline,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {
	getPatientList,
	getUserSettings,
	postUserSettings,
	updateUserSettings,
} from '../../../services/api/apiManager';
import { ClearIcon } from '@mui/x-date-pickers-pro';

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	backgroundColor: '#fff',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

const modalButtonSx = {
	height: '40px',
	borderRadius: '6px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
};

const outlineButtonSx = {
	...modalButtonSx,
	minWidth: '112px',
	border: '1px solid #cfd9e8',
	backgroundColor: '#fff',
	color: '#344054',
	'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
};

const primaryButtonSx = {
	...modalButtonSx,
	minWidth: '122px',
	backgroundColor: '#2f6edb',
	color: '#fff',
	boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
	'&:hover': { backgroundColor: '#245fc5' },
	'&.Mui-disabled': {
		backgroundColor: '#d7dce5',
		color: '#98a2b3',
		boxShadow: 'none',
	},
};

function FavouritePatientList() {
	const practiceID = localStorage.getItem('practice_id');
	const [loading, setLoading] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [addListAnchorEl, setAddListAnchorEl] = useState(null);
	const [settingID, setSettingID] = useState(0);
	const [addSettingName, setAddSettingName] = useState('');
	const [favouritePatientList, setFavouritePatientList] = useState([]);
	const [patientList, setPatientList] = useState([]);
	const [selectedPatient, setSelectedPatient] = useState([]);
	const [currentOpennedSettingPatients, setCurrentOpennedSettingPatients] =
		useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [editFavouritePatientListDialog, setEditFavouritePatientListDialog] =
		useState(false);
	// WARNING! I am using same modal for delete and rename the setting name
	const [deleteOrEditModal, setDeleteOrEditModal] = useState({
		open: false,
		settingName: '',
		modalFor: '',
	});
	// warning I am using Same Snackbar for add,update,delete
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [snackbarInfo, setSnackbarInfo] = useState({
		snackbarMsg: '',
		snackbarColor: '',
	});

	const handleChange = function (accordianID) {
		return function (event, isExpanded) {
			return setExpanded(isExpanded ? accordianID : false);
		};
	};

	// function which is used to retrieve all favourite patient list from our settingslist
	const getUserSetting = async () => {
		setLoading(true);
		try {
			const resp = await getUserSettings();
			if (resp?.status === 200) {
				setFavouritePatientList(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'PAT' || items?.Type === 'pat')
							);
						})
						?.reverse()
				);

				setLoading(false);
			} else {
				setFavouritePatientList([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};

	const getAllPatientList = async (practiceID) => {
		const resp = await getPatientList(practiceID);
		if (resp.status === 200 || resp.status === 201) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	// function for aading new User Settings Name
	const addUserSetting = async (data) => {
		const resp = await postUserSettings(data);
		if (resp?.status === 201) {
			getUserSetting();
			setAddSettingName('');
			setSnackbarInfo({ snackbarColor: 'green', snackbarMsg: 'new' });
		} else {
			setSnackbarInfo({ snackbarColor: 'red', snackbarMsg: 'error' });
		}
		setOpenSnackbar(true);
	};

	const updateUserSetting = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			getUserSetting();
			setExpanded(false);
			setAddSettingName('');
			setSelectedPatient([]);
			setCurrentOpennedSettingPatients([]);
			setSnackbarInfo(
				resp?.data?.Deleted === true
					? { snackbarColor: 'green', snackbarMsg: 'delete' }
					: { snackbarColor: 'green', snackbarMsg: 'update' }
			);
		} else {
			setSnackbarInfo({ snackbarColor: 'red', snackbarMsg: 'error' });
		}
		setOpenSnackbar(true);
	};

	const DeleteFavouriteListPatient = async (id, data) => {
		const resp = await updateUserSettings(id, data);
		if (resp?.status === 200) {
			setSnackbarInfo({ snackbarColor: 'green', snackbarMsg: 'delete' });
			//for getting all user setting details I can call getUserSetting()  function again here but there was loader in it and i dont want that loader
			const resp = await getUserSettings();
			setFavouritePatientList(
				resp?.data
					?.filter((items) => {
						return (
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'PAT' || items?.Type === 'pat')
						);
					})
					?.reverse()
			);
		}
		setOpenSnackbar(true);
	};
	useEffect(() => {
		getUserSetting();
		getAllPatientList(practiceID);
	}, []);
	const filterPatient = patientList?.filter((options) => {
		return options?.Inactive !== false && options?.Inactive !== null;
	});

	const [searchFavPatient, setSearchFavPatient] = useState('');
	const filterFavPatient = favouritePatientList?.filter((items) => {
		return (
			searchFavPatient === '' ||
			items?.SettingName?.toLowerCase().includes(searchFavPatient.toLowerCase())
		);
	});
	return (
		<>
			{loading ? (
				<BrandedLoader
					title="Loading favorite patients"
					text="Preparing saved patient settings"
				/>
			) : (
				<>
					<Box
						sx={{
							width: '100%',
							minHeight: 'calc(100vh - 170px)',
							background: '#f5f8fc',
							border: '1px solid #e3edf8',
							borderRadius: '8px',
							p: 2,
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: { xs: 'flex-start', sm: 'center' },
								gap: 2,
								mb: 2.5,
								flexDirection: { xs: 'column', sm: 'row' },
							}}
						>
							<Box>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '20px',
										color: '#0b2450',
										lineHeight: 1.2,
									}}
								>
									Favourite Patient Lists
								</Typography>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										color: '#64748b',
										mt: 0.6,
									}}
								>
									View, manage and organize your favourite patient lists.
								</Typography>
							</Box>
							<Button
								variant="contained"
								startIcon={<Add sx={{ fontSize: '18px' }} />}
								onClick={(event) => {
									setAddListAnchorEl((prevaAnchorEl) =>
										prevaAnchorEl ? null : event.currentTarget
									);
								}}
								sx={{
									minWidth: '110px',
									height: '38px',
									bgcolor: '#2f6edb',
									borderRadius: '6px',
									color: '#FFFFFF',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
									'&:hover': { background: '#245fc5' },
								}}
							>
								Add List
							</Button>
						</Box>
						<Box
							sx={{
								background: '#fff',
								border: '1px solid #e3edf8',
								borderRadius: '8px',
								p: 1.8,
								maxHeight: 'calc(100vh - 265px)',
								overflow: 'auto',
							}}
						>
							<Box display={'flex'} sx={{ mb: 1.5, maxWidth: 360 }}>
								<TextField
									placeholder="Search favourite list..."
									variant="outlined"
									size="small"
									value={searchFavPatient}
									onChange={(event) => {
										setSearchFavPatient(event.target.value);
									}}
									InputProps={{
										startAdornment: (
											<SearchIcon
												sx={{ color: '#71839f', fontSize: '18px', mr: 1 }}
											/>
										),
									}}
									sx={{
										'& input': {
											color: '#0b2450',
											fontSize: '13px',
											fontFamily: 'Poppins',
											padding: '9px 12px',
										},
										'& .MuiOutlinedInput-root': {
											height: '40px',
											borderRadius: '6px',
											'& fieldset': {
												borderColor: '#d7e3f4',
											},
											'&.Mui-focused fieldset': {
												borderColor: '#2f6edb',
												borderWidth: '1px',
											},
											'&:hover fieldset': {
												borderColor: '#b8c9e0',
											},
										},
									}}
								/>
							</Box>
							{!favouritePatientList?.length > 0 ? (
								<>
									<Box
										width={'100%'}
										height={'45vh'}
										display={'flex'}
										justifyContent={'center'}
										alignItems={'center'}
									>
										<Box>
											<span
												style={{
													color: '#0D406F',
													width: '200px',
													margin: 'auto',
													fontWeight: 600,
												}}
											>
												0
											</span>
											&nbsp;
											<span style={{ fontWeight: 600 }}> Record</span>
										</Box>
									</Box>
								</>
							) : (
								<Grid container sx={{ gap: 1.2 }} overflow={'auto'}>
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										{filterFavPatient?.map((items, index) => {
											const isExpanded = expanded == items?.id;
											return (
												<Box
													key={items?.id}
													sx={{
														border: '1px solid #e3edf8',
														borderRadius: '8px',
														mb: 1.2,
														background: '#fff',
														boxShadow: '0 3px 10px rgba(15, 23, 42, 0.06)',
														overflow: 'hidden',
													}}
												>
													<Box
														sx={{
															minHeight: 42,
															display: 'flex',
															alignItems: 'center',
															gap: 1.2,
															px: 1.2,
														}}
													>
														<Box
															sx={{
																width: 28,
																height: 28,
																borderRadius: '50%',
																bgcolor: '#eef4ff',
																color: '#2f6edb',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																flex: '0 0 auto',
															}}
														>
															<ListAltOutlined sx={{ fontSize: '16px' }} />
														</Box>
														<Typography
															sx={{
																fontSize: '13px',
																fontWeight: 700,
																fontFamily: 'Poppins',
																color: '#19365f',
																flex: 1,
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																whiteSpace: 'nowrap',
															}}
														>
															{items?.SettingName}
														</Typography>
														<IconButton
															size="small"
															onClick={() => {
																if (isExpanded) {
																	setExpanded(false);
																	setCurrentOpennedSettingPatients([]);
																	return;
																}
																setExpanded(items?.id);
																setCurrentOpennedSettingPatients(
																	items?.setting_codes || []
																);
															}}
															sx={{ color: '#3f5f91', mr: 1 }}
														>
															{isExpanded ? <ExpandLess /> : <ExpandMore />}
														</IconButton>
														<IconButton
															onClick={() => {
																setCurrentOpennedSettingPatients(
																	items?.setting_codes
																);
																setSettingID(items?.id);
																setEditFavouritePatientListDialog(true);
															}}
															sx={{
																width: 32,
																height: 32,
																borderRadius: '6px',
																bgcolor: '#2bb45a',
																color: '#fff',
																mr: 0.6,
																'&:hover': { bgcolor: '#22984b' },
															}}
														>
															<Add sx={{ fontSize: '18px' }} />
														</IconButton>
														<IconButton
															onClick={() => {
																setAddSettingName(items?.SettingName);
																setSettingID(items?.id);
																setDeleteOrEditModal({
																	open: true,
																	settingName: items?.SettingName,
																	modalFor: 'editModal',
																});
															}}
															sx={{
																width: 32,
																height: 32,
																borderRadius: '6px',
																bgcolor: '#1d60c5',
																color: '#fff',
																mr: 0.6,
																'&:hover': { bgcolor: '#164fa5' },
															}}
														>
															<EditOutlined sx={{ fontSize: '17px' }} />
														</IconButton>
														<IconButton
															onClick={() => {
																setDeleteOrEditModal({
																	open: true,
																	settingName: items?.SettingName,
																});
																setSettingID(items?.id);
															}}
															sx={{
																width: 32,
																height: 32,
																borderRadius: '6px',
																bgcolor: '#ef4444',
																color: '#fff',
																'&:hover': { bgcolor: '#dc2626' },
															}}
														>
															<DeleteOutline sx={{ fontSize: '18px' }} />
														</IconButton>
													</Box>
													{isExpanded && (
														<Box
															sx={{
																borderTop: '1px solid #e3edf8',
																background: '#f7fbff',
																px: 2,
																py: 1.2,
																maxHeight: '20vh',
																overflow: 'auto',
															}}
														>
															{currentOpennedSettingPatients?.length === 0 ? (
																<Typography
																	sx={{
																		fontFamily: 'Poppins',
																		fontSize: '12px',
																		color: '#64748b',
																	}}
																>
																	No patients added yet.
																</Typography>
															) : (
																currentOpennedSettingPatients?.map(
																	(innerItems, index) => (
																		<Box
																			key={index}
																			sx={{
																				display: 'grid',
																				gridTemplateColumns: '1fr 32px',
																				alignItems: 'center',
																				gap: 1,
																				minHeight: 36,
																				borderBottom: '1px solid #e6eef8',
																				'&:last-child': { borderBottom: 0 },
																			}}
																		>
																			<Typography
																				sx={{
																					color: '#1D60C5',
																					fontSize: '13px',
																					fontWeight: 600,
																					fontFamily: 'Poppins',
																					overflow: 'hidden',
																					textOverflow: 'ellipsis',
																					whiteSpace: 'nowrap',
																				}}
																			>
																				{innerItems?.CodeDescription}
																			</Typography>
																			<IconButton
																				size="small"
																				onClick={() => {
																					const afterDeleteIconClicked =
																						currentOpennedSettingPatients?.filter(
																							(patient) =>
																								patient?.id !== innerItems.id
																						);
																					setCurrentOpennedSettingPatients(
																						afterDeleteIconClicked
																					);
																					DeleteFavouriteListPatient(
																						items?.id,
																						{
																							setting_codes:
																								afterDeleteIconClicked,
																						}
																					);
																				}}
																				sx={{ color: '#ef4444' }}
																			>
																				<Delete sx={{ fontSize: '20px' }} />
																			</IconButton>
																		</Box>
																	)
																)
															)}
														</Box>
													)}
												</Box>
											);
										})}
									</Grid>
								</Grid>
							)}
						</Box>
					</Box>
				</>
			)}

			{/* Add Patient to Favourite list from this Dialog */}
			<Dialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				PaperProps={{
					sx: {
						width: 'min(680px, calc(100vw - 32px))',
						borderRadius: '10px',
						overflow: 'hidden',
						m: 0,
					},
				}}
			>
				<Box sx={{ background: '#fff' }}>
					<Box
						sx={{
							height: 58,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							borderBottom: '1px solid #edf2f8',
							px: 2.2,
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '18px',
								fontWeight: 700,
								color: '#0b2450',
							}}
						>
							Select Patients
						</Typography>
						<IconButton
							size="small"
							onClick={() => {
								setOpenDialog(false);
								setAddSettingName('');
								setSelectedPatient([]);
							}}
							sx={{ color: '#0b2450' }}
						>
							<Close sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>

					<Box sx={{ p: 2.4, minHeight: 220 }}>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 600,
								color: '#0b2450',
								mb: 0.8,
							}}
						>
							Patients
						</Typography>
						<Autocomplete
							multiple
							size="small"
							limitTags={3}
							id="checkboxes-tags-demo"
							options={patientList}
							disableCloseOnSelect
							getOptionLabel={(option) => option?.Name}
							renderTags={(value, getTagProps) =>
								selectedPatient.map((items, index) => (
									<Chip
										deleteIcon={<RemoveCircleOutline />}
										onDelete={() => {
											const removeCodes = selectedPatient?.filter(
												(selectedPatients) =>
													selectedPatients?.Code !== items?.Code
											);
											setSelectedPatient(removeCodes);
										}}
										key={index}
										variant="outlined"
										label={items?.CodeDescription}
										sx={{ fontFamily: 'Poppins', fontSize: '12px', height: 26 }}
									/>
								))
							}
							clearIcon={
								<ClearIcon
									fontSize="small"
									onClick={() => setSelectedPatient([])}
								/>
							}
							renderOption={(props, option) => (
								<Box
									key={option?.patient_id}
									{...props}
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										minHeight: 36,
										py: 0.5,
									}}
								>
									<Checkbox
										id={option?.patient_id}
										icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
										checkedIcon={<CheckBoxIcon fontSize="small" />}
										style={{ marginRight: 8 }}
										checked={selectedPatient?.some(
											(items) => items?.Code == option?.patient_id
										)}
										sx={{ fontSize: '13px' }}
										value={option?.patient_id}
										onChange={(e) => {
											if (e.target.checked) {
												setSelectedPatient((prev) => [
													...prev,
													{
														setting_id: settingID,
														CodeType: 'pat',
														Code: e.target.value,
														CodeDescription: option?.Name,
													},
												]);
											} else {
												const removeCodes = selectedPatient.filter(
													(items) => items?.Code !== e.target.value
												);
												setSelectedPatient(removeCodes);
											}
										}}
									/>
									{option?.Name}
								</Box>
							)}
							PaperComponent={CustomPaper}
							PopperComponent={CustomPopper}
							sx={{
								width: '100%',
								'& .MuiOutlinedInput-root': {
									minHeight: '42px',
									borderRadius: '6px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									'& fieldset': { borderColor: '#d7e3f4' },
									'&:hover fieldset': { borderColor: '#b8c9e0' },
									'&.Mui-focused fieldset': {
										borderColor: '#2f6edb',
										borderWidth: '1px',
									},
								},
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder="Search and select patients"
								/>
							)}
						/>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: 1.5,
							borderTop: '1px solid #edf2f8',
							px: 2.4,
							py: 1.5,
						}}
					>
						<Button
							startIcon={<Close sx={{ fontSize: '18px' }} />}
							sx={outlineButtonSx}
							onClick={() => {
								setOpenDialog(false);
								setAddSettingName('');
								setSelectedPatient([]);
							}}
						>
							Cancel
						</Button>
						<Button
							disabled={selectedPatient.length === 0}
							startIcon={<Add sx={{ fontSize: '18px' }} />}
							sx={primaryButtonSx}
							onClick={() => {
								addUserSetting({
									practice_id: practiceID,
									Type: 'pat',
									SettingName: addSettingName,
									setting_codes: selectedPatient,
								});
								setSelectedPatient([]);
								setOpenDialog(false);
							}}
						>
							Add Patients
						</Button>
					</Box>
				</Box>
			</Dialog>

			{/* Edit your Favourite Patients in the list from this dialog */}
			<Dialog
				open={editFavouritePatientListDialog}
				onClose={() => setEditFavouritePatientListDialog(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				PaperProps={{
					sx: {
						width: 'min(680px, calc(100vw - 32px))',
						borderRadius: '10px',
						overflow: 'hidden',
						m: 0,
					},
				}}
			>
				<Box sx={{ background: '#fff' }}>
					<Box
						sx={{
							height: 58,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							borderBottom: '1px solid #edf2f8',
							px: 2.2,
						}}
					>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '18px',
								fontWeight: 700,
								color: '#0b2450',
							}}
						>
							Update Favourite Patients
						</Typography>
						<IconButton
							size="small"
							onClick={() => {
								setExpanded(false);
								setEditFavouritePatientListDialog(false);
								setCurrentOpennedSettingPatients([]);
							}}
							sx={{ color: '#0b2450' }}
						>
							<Close sx={{ fontSize: '22px' }} />
						</IconButton>
					</Box>

					<Box sx={{ p: 2.4, minHeight: 220 }}>
						<Typography
							sx={{
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 600,
								color: '#0b2450',
								mb: 0.8,
							}}
						>
							Patients
						</Typography>
						<Autocomplete
							multiple
							size="small"
							limitTags={3}
							id="checkboxes-tags-updateFavPatList"
							options={patientList?.filter(
								(options) => options?.Inactive !== true
							)}
							disableCloseOnSelect
							getOptionLabel={(option) => option?.Name}
							defaultValue={['']}
							renderTags={(value, getTagProps) =>
								currentOpennedSettingPatients.map((items, index) => (
									<Chip
										deleteIcon={<RemoveCircleOutline />}
										onDelete={() => {
											const removeCodes = currentOpennedSettingPatients?.filter(
												(selectedPatients) =>
													selectedPatients?.Code !== items?.Code
											);
											setCurrentOpennedSettingPatients(removeCodes);
										}}
										key={index}
										variant="outlined"
										label={items?.CodeDescription}
										sx={{ fontFamily: 'Poppins', fontSize: '12px', height: 26 }}
									/>
								))
							}
							clearIcon={
								<ClearIcon
									fontSize="small"
									onClick={() => setCurrentOpennedSettingPatients([])}
								/>
							}
							renderOption={(props, option) => (
								<Box
									key={option?.patient_id}
									{...props}
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										minHeight: 36,
										py: 0.5,
									}}
								>
									<Checkbox
										id={option?.patient_id}
										icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
										checkedIcon={<CheckBoxIcon fontSize="small" />}
										style={{ marginRight: 8 }}
										checked={currentOpennedSettingPatients?.some(
											(items) => items?.Code == option?.patient_id
										)}
										sx={{ fontSize: '13px' }}
										value={option?.patient_id}
										onChange={(e) => {
											if (e.target.checked) {
												setCurrentOpennedSettingPatients((prev) => [
													...prev,
													{
														setting_id: settingID,
														CodeType: 'pat',
														Code: e.target.value,
														CodeDescription: option?.Name,
													},
												]);
											} else {
												const removeCodes =
													currentOpennedSettingPatients.filter(
														(items) => items?.Code !== e.target.value
													);
												setCurrentOpennedSettingPatients(removeCodes);
											}
										}}
									/>
									{option?.Name}
								</Box>
							)}
							PaperComponent={CustomPaper}
							PopperComponent={CustomPopper}
							sx={{
								width: '100%',
								'& .MuiOutlinedInput-root': {
									minHeight: '42px',
									borderRadius: '6px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									'& fieldset': { borderColor: '#d7e3f4' },
									'&:hover fieldset': { borderColor: '#b8c9e0' },
									'&.Mui-focused fieldset': {
										borderColor: '#2f6edb',
										borderWidth: '1px',
									},
								},
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder="Search and select patients"
								/>
							)}
						/>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: 1.5,
							borderTop: '1px solid #edf2f8',
							px: 2.4,
							py: 1.5,
						}}
					>
						<Button
							startIcon={<Close sx={{ fontSize: '18px' }} />}
							sx={outlineButtonSx}
							onClick={() => {
								setExpanded(false);
								setEditFavouritePatientListDialog(false);
								setAddSettingName('');
								setCurrentOpennedSettingPatients([]);
							}}
						>
							Cancel
						</Button>
						<Button
							disabled={currentOpennedSettingPatients.length === 0}
							startIcon={<EditOutlined sx={{ fontSize: '18px' }} />}
							sx={primaryButtonSx}
							onClick={() => {
								updateUserSetting(settingID, {
									setting_codes: currentOpennedSettingPatients,
								});
								setCurrentOpennedSettingPatients([]);
								setEditFavouritePatientListDialog(false);
								setExpanded(false);
							}}
						>
							Update Patients
						</Button>
					</Box>
				</Box>
			</Dialog>
			{/* Add list Popper */}
			<Popper
				sx={{ zIndex: 9 }}
				id={'add-list-popper'}
				open={addListAnchorEl}
				anchorEl={addListAnchorEl}
			>
				<Box
					sx={{
						width: 300,
						borderRadius: '8px',
						boxShadow: '0 12px 28px rgba(15, 23, 42, 0.16)',
						padding: '14px',
						background: '#FFFFFF',
						border: '1px solid #dce8f5',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginBottom: '10px',
						}}
					>
						<Typography
							variant="body2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 700,
								color: '#0b2450',
							}}
						>
							Add List Name
						</Typography>
						<IconButton
							size="small"
							onClick={() => {
								setAddListAnchorEl(null);
								setAddSettingName('');
							}}
							aria-describedby={'add-list-popper'}
							sx={{ color: '#64748b' }}
						>
							<Close sx={{ fontSize: '18px' }} />
						</IconButton>
					</Box>
					<Input
						id="settingNameField"
						disableUnderline
						type="text"
						fullWidth
						value={addSettingName}
						onChange={(e) => setAddSettingName(e.target.value)}
						placeholder="Enter List Name"
						sx={{
							borderRadius: '6px',
							border: '1px solid #d7e3f4',
							height: '40px',
							padding: '0 12px',
							marginBottom: '6px',
							fontFamily: 'Poppins',
							fontSize: '13px',
							color: '#0b2450',
							'&:focus-within': { borderColor: '#2f6edb' },
						}}
					/>
					{addSettingName === '' && (
						<FormHelperText
							sx={{
								color: '#ef4444',
								fontFamily: 'Poppins',
								fontSize: '11px',
								mb: 1,
							}}
						>{`Name should\'t be Empty`}</FormHelperText>
					)}
					<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							disabled={addSettingName === ''}
							onClick={() => {
								setAddListAnchorEl(null);
								setOpenDialog(true);
							}}
							sx={{
								...primaryButtonSx,
								minWidth: '96px',
								height: '36px',
							}}
						>
							Proceed
						</Button>
					</Box>
				</Box>
			</Popper>

			{/* delete and edit setting name Moal */}
			{/* WARNING! I am using same modal for delete and rename the setting name and using conditional renderings for delete button and edit button  */}
			<Modal
				open={deleteOrEditModal?.open}
				onClose={() => {
					setDeleteOrEditModal({ open: false });
				}}
				aria-labelledby="delete-modal-title"
				aria-describedby="delete-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '0.75 !important',
					},
				}}
			>
				<Box
					sx={{
						...modalStyle,
						width:
							deleteOrEditModal.modalFor === 'editModal'
								? 'min(520px, calc(100vw - 32px))'
								: 'min(410px, calc(100vw - 32px))',
						overflow: 'hidden',
					}}
				>
					{deleteOrEditModal.modalFor === 'editModal' ? (
						<>
							<Box
								sx={{
									height: '60px',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									borderBottom: '1px solid #edf2f8',
									px: 2,
								}}
							>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '20px',
										fontWeight: 700,
										color: '#111827',
									}}
								>
									Rename Favourite List
								</Typography>
								<IconButton
									onClick={() => {
										setDeleteOrEditModal({ open: false });
										setAddSettingName('');
									}}
									sx={{ color: '#475569' }}
								>
									<Close sx={{ fontSize: '22px' }} />
								</IconButton>
							</Box>
							<Box sx={{ width: '100%', p: 2.4 }}>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '13px',
										fontWeight: 600,
										color: '#0b2450',
										mb: 0.8,
									}}
								>
									List Name
								</Typography>
								<Box>
									<TextField
										id="settingNameField"
										disableUnderline
										size="small"
										type="text"
										fullWidth
										value={addSettingName}
										onChange={(e) => setAddSettingName(e.target.value)}
										placeholder="Update List Name"
										sx={{
											'& .MuiOutlinedInput-root': {
												height: '42px',
												borderRadius: '6px',
												fontFamily: 'Poppins',
												fontSize: '13px',
												'& fieldset': { borderColor: '#d7e3f4' },
												'&:hover fieldset': { borderColor: '#b8c9e0' },
												'&.Mui-focused fieldset': {
													borderColor: '#2f6edb',
													borderWidth: '1px',
												},
											},
										}}
									/>
								</Box>
							</Box>
							<Box
								width={'100%'}
								display={'flex'}
								alignItems={'center'}
								justifyContent={'flex-end'}
								gap={1.5}
								sx={{ borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}
							>
								<Button
									onClick={() => {
										setDeleteOrEditModal({ open: false });
										setAddSettingName('');
									}}
									startIcon={<Close sx={{ fontSize: '18px' }} />}
									sx={outlineButtonSx}
								>
									Cancel
								</Button>
								<Button
									startIcon={<EditOutlined sx={{ fontSize: '18px' }} />}
									sx={primaryButtonSx}
									onClick={() => {
										updateUserSetting(settingID, {
											SettingName: addSettingName,
										});
										setDeleteOrEditModal({ open: false });
									}}
								>
									Rename
								</Button>
							</Box>
						</>
					) : (
						<>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									p: '12px 12px 0',
								}}
							>
								<IconButton
									size="small"
									onClick={() => {
										setDeleteOrEditModal({ open: false });
										setAddSettingName('');
									}}
									sx={{ width: 32, height: 32, color: '#64748b' }}
								>
									<Close sx={{ fontSize: '20px' }} />
								</IconButton>
							</Box>
							<Box sx={{ px: 3, pt: 1, pb: 3, textAlign: 'center' }}>
								<Box
									sx={{
										width: 74,
										height: 74,
										borderRadius: '50%',
										background: '#fff1f2',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										mx: 'auto',
										mb: 2,
									}}
								>
									<Box
										sx={{
											width: 52,
											height: 52,
											borderRadius: '50%',
											background: '#ffe4e6',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<DeleteOutline
											sx={{ color: '#ef4444', fontSize: '30px' }}
										/>
									</Box>
								</Box>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 500,
										fontSize: '15px',
										color: '#1f2937',
										mb: 1,
									}}
								>
									Are you sure you want to delete this favourite patient list?
								</Typography>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '14px',
										color: '#005eff',
										lineHeight: 1.45,
										wordBreak: 'break-word',
									}}
								>
									{deleteOrEditModal?.settingName}
								</Typography>
							</Box>
							<Box
								sx={{
									display: 'grid',
									gridTemplateColumns: '1fr 1fr',
									gap: 1.5,
									px: 3,
									py: 2.5,
									borderTop: '1px solid #edf2f8',
								}}
							>
								<Button
									onClick={() => {
										setDeleteOrEditModal({ open: false });
										setAddSettingName('');
									}}
									startIcon={<Close sx={{ fontSize: '18px' }} />}
									sx={{
										...outlineButtonSx,
										minWidth: 0,
										color: '#ef4444',
										'&:hover': {
											background: '#fff5f5',
											borderColor: '#fecaca',
										},
									}}
								>
									No
								</Button>
								<Button
									startIcon={<DeleteOutline sx={{ fontSize: '18px' }} />}
									sx={{ ...primaryButtonSx, minWidth: 0 }}
									onClick={() => {
										updateUserSetting(settingID, {
											Deleted: true,
										});
										setDeleteOrEditModal({ open: false });
									}}
								>
									Yes
								</Button>
							</Box>
						</>
					)}
				</Box>
			</Modal>
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={() => setOpenSnackbar(false)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={() => setOpenSnackbar(false)}
					severity={snackbarInfo.snackbarColor === 'red' ? 'error' : 'success'}
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					{snackbarInfo.snackbarMsg === 'new'
						? `New Favourite Patient Setting Added Successfully!`
						: snackbarInfo.snackbarMsg === 'update'
							? ` Updated Successfully!`
							: snackbarInfo.snackbarMsg === 'delete'
								? `Deleted SuccessFully!`
								: openSnackbar.snackbarFor === 'error'
									? 'ERROR!'
									: ''}
				</Alert>
			</Snackbar>
		</>
	);
}

export default FavouritePatientList;

// popers and paper MUI functions
const CustomPaper = (props) => {
	return (
		<Paper
			{...props}
			sx={{
				borderRadius: 2,
				height: '10%',
				overflow: 'auto',
				'&amp; .MuiAutocomplete-listbox': {
					// maxHeight: '100%',
					padding: 1,
					'&amp; .MuiAutocomplete-option': {
						minHeight: 48,
						padding: '10px 16px',
						'&amp;[aria-selected="true"]': {
							backgroundColor: '#3F9943',
							color: 'white',
						},
						'&amp;[data-focus="true"]': {
							backgroundColor: '#d0f0d0',
						},
					},
				},
			}}
		/>
	);
};

const CustomPopper = (props) => (
	<Popper
		{...props}
		sx={{
			zIndex: 1500,
		}}
	/>
);
